import { render, staticRenderFns } from "./numberProperty.vue?vue&type=template&id=59c63f0c&scoped=true&"
import script from "./numberProperty.vue?vue&type=script&lang=js&"
export * from "./numberProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c63f0c",
  null
  
)

export default component.exports